import React, { useState, useEffect } from "react";
import "./style.scss";
import Heading from "../../elements/heading";
import Input from "../../elements/input";
import Checkbox from "../../elements/checkbox";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import PropTypes from "prop-types";

const ResetPasswordForm = ({ headingType, headingBody, body, email, emailLabel, emailWarningMessage, emailMissingMessage, emailNotExistMessage, maxRequestReachedMessage, sendLinkFailedMessage, submitButton, sendResetPasswordLink, onNextStep, disclaimer }) => {
  const [serverError, setServerError] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [formDataEmail, setEmail] = useState(email);
  const [emailValidationHasError, setEmailValidationHasError] = useState();
  const [emailHasError, setEmailHasError] = useState();
  useEffect(() => {
    setEmail(email);
  }, [email]);
  const onEmailChange = (evt, isValid) => {
    setEmail(evt.target.value);
    setEmailValidationHasError(!isValid);
    setEmailHasError(false);
  };
  const submitResetPassword = async (evt, data) => {
    if (evt) {
      evt.stopPropagation();
      evt.preventDefault();
    }
    try {
      await sendResetPasswordLink(evt, data);
      onNextStep && onNextStep(formDataEmail);
    } catch (res) {
      switch (res.code) {
        // case "EMAIL_EXCEPTION_001":
        //   setEmailIsValid(false);
        //   break;
        case "USER_CUSTOMER_0003":
          setServerError(emailNotExistMessage.value);
          break;
        case "USER_CUSTOMER_0013":
          setIsDisabled(true);
          setServerError(maxRequestReachedMessage.value);
          break;
        default:
          setServerError(sendLinkFailedMessage.value);
          break;
      }
    }
  };
  const onSubmit = async evt => {
    evt && evt.preventDefault();

    if (!formDataEmail) {
      setEmailHasError(true);
    }

    if (!emailValidationHasError && formDataEmail) {
      const formData = { email: formDataEmail };
      await submitResetPassword(evt, formData);
    } else {
      evt.target.focus();
    }
  };

  return (
    <form className="reset-password-form" onSubmit={evt => onSubmit(evt)}>
      {headingType && headingBody && <Heading type={headingType} className="title show-on-scroll" html={headingBody} typographyClass={"type-h3"} />}
      {emailLabel && (
        <Input
          {...{
            type: "email",
            label: emailLabel.value,
            value: formDataEmail,
            warningMessage: emailValidationHasError ? emailWarningMessage.value : emailMissingMessage.value,
            showError: emailHasError,
            onChange: (evt, isValid) => onEmailChange(evt, isValid)
          }}
        />
      )}

      {serverError && <BodyText className="failed-message" html={serverError} />}

      {disclaimer.termsCheckbox && <Checkbox {...{ ...disclaimer.termsCheckbox, onChange: () => {} }} />}
      <div className="button-container">{submitButton && <PrimaryButton {...{ ...submitButton, isDisabled, callback: evt => onSubmit(evt) }} />}</div>

      {body && <BodyText html={body.value} className="disclaimer" />}
    </form>
  );
};

ResetPasswordForm.propTypes = {
  heading: PropTypes.object,
  email: PropTypes.string,
  submitButton: PropTypes.object,
  submitResetPassword: PropTypes.func,
  serverError: PropTypes.string,
  disclaimer: PropTypes.shape({
    showCheckbox: PropTypes.bool,
    termsCheckbox: PropTypes.any,
    body: PropTypes.any
  })
};

ResetPasswordForm.defaultProps = {
  submitResetPassword: () => {},
  disclaimer: { body: "" }
};

export default ResetPasswordForm;
